
// HOW TO USE
// ----------
// colorLuminance('#ff0000', 0.2);
// returns 20% lighter than red.
//
// colorLuminance('#ff0000', -0.2);
// return 20% darker than red.

// validate hex string

module.exports = {
    colorLuminance(_hex, _lum) {
        let hex = String(_hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        const lum = _lum || 0;
        let rgb = '#';
        let c;
        let i;

        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += (`00${c}`).substr(c.length);
        }
        return rgb;
    },

    convertHex(_hex, _opacity) {
        const hex = _hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result = `rgba(${r},${g},${b},${_opacity / 100})`;
        return result;
    },
};



/** WEBPACK FOOTER **
 ** ./client/lib/colorLuminance.js
 **/